import React, {
  forwardRef,
  isValidElement,
  useImperativeHandle,
  useState,
} from "react";
import RadioButton from "../../../generic/radioButton";
import { IListObj } from "../../../types/genericTypes";
import { TaxResident } from "./taxResident";
import { StatusScreen } from "../../generic/statusScreen";
import {
  CreateServiceRequestDetails,
  fatcavalidation,
  GetDepositoryDetails,
  ServiceClientValidation,
} from "../../../service/serviceRequest/srApiService";
import { FailedValidationScreen } from "../../generic/failedValidationScreen";
import Loader from "../../../generic/loader";

const radioValues: Array<IListObj> = [
  { value: "true", display: "Yes" },
  { value: "false", display: "No" },
];
export const FatcaUpdate = forwardRef((props: any, ref: any) => {
  const [taxForm, setTaxForm] = useState<any | null>([
    {
      country: "",
      idType: "",
      idNo: "",
      idTypeOther: "TIN",
      idNoError: "",
      nodisplayError: "",
    },
  ]);
  const [checkStatus, setCheckStatus] = useState<any>();
  const [SelectedRadio, setSelectedRadio] = useState<any>(true);
  const [listing, setListing] = useState<any>();
  const [childSr, setChildSr] = useState(props.childSr ? props.childSr : false);
  //const [loader, setLoader] = useState<any>(true);

  React.useEffect(() => {
    props.setLoader(true);
    if (!childSr) {
      if (checkStatus) props.setLoader(false);
      if (checkStatus === "FATCA Validation is Success") {
        props.showFooter(true);
      } else {
        props.showFooter(false);
      }
    } else {
      if (checkStatus) {
        props.setLoader(false);
        if (checkStatus !== "FATCA Validation is Success") {
          props.hide(true);
        }
      }
    }
  }, [checkStatus]);

  React.useEffect(() => {
    validation();
    // if (!childSr) validation();
    // else {
    //   setCheckStatus("FATCA Validation is Success");
    //   props.setLoader(false);
    // }
  }, []);

  React.useEffect(() => {
    if (SelectedRadio) {
      props.enableSubmit(true);
      if (props.childSr) {
        props.childSrB(true);
      }
    } else {
      let isValid = taxForm.every((ele: any) => {
        return (
          ele.country &&
          ele.idTypeOther &&
          ele.idNo &&
          !ele.idNoError &&
          !ele.nodisplayError
        );
      });
      if (isValid) {
        props.enableSubmit(true);
      } else {
        props.enableSubmit(false);
      }
      if (props.childSr) {
        // let childSrdisable =
        //   isValid && !error.error0 && !error.error1 && !error.error2;
        props.childSrB(isValid);
      }
    }
  }, [taxForm, SelectedRadio]);
  const openSRErrorPopup = () => {
    props.onSubmit("FATCA Update", {
      headerText:
        "There was some problem in raising service request. Please try again later.",
    });
  };
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("FATCA Update", {
      headerText: "You have an active service request",
      content: "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };

  const validation = async () => {
    try {
      let fatcaValidation = await fatcavalidation();
      // let serviceClientValidation = await ServiceClientValidation({
      //   subtype: "FATCA Declaration",
      // });
      let serviceClientValidation = "BOAcoountNumber not found";
      if (fatcaValidation && serviceClientValidation) {
        if (
          fatcaValidation.match("FATCA Validation is Success") &&
          serviceClientValidation.match("BOAcoountNumber not found")
        ) {
          setCheckStatus(fatcaValidation);
        } else if (fatcaValidation === "Your FATCA is updated") {
          setCheckStatus(fatcaValidation);
        } else if (
          fatcaValidation ===
          "Your FATCA Validation has failed. Please get in touch with your RM."
        ) {
          setCheckStatus(fatcaValidation);
        } else if (
          fatcaValidation === "FATCA Validation is Success" &&
          serviceClientValidation ===
            "Another FATCA request is under process. Please raise any new requests only once those are processed"
        ) {
          setCheckStatus(serviceClientValidation);
        } else {
          setCheckStatus(fatcaValidation);
        }
      }
      props.setLoader(false);
    } catch (error) {
      openSRErrorPopup();
    }
  };

  const onchanges = (name?: string, value?: any) => {
    setListing({ name, value });
    if (value.match("false")) {
      setSelectedRadio(false);
      props.enableSubmit(false);
    } else {
      setSelectedRadio(true);
      setTaxForm([
        {
          country: "",
          idType: "",
          idNo: "",
          idTypeOther: "TIN",
          idNoError: "",
        },
      ]);
    }
  };
  const getDepositoryDet = async () => {
    try {
      const resp = await GetDepositoryDetails();

      if (resp && resp.dPIdField && resp.dPAccountNumberField) {
        return resp.dPIdField + resp.dPAccountNumberField;
      } else {
        return "None";
      }
    } catch (error) {
      openSRErrorPopup();
    }
  };
  useImperativeHandle(ref, () => ({
    async getSubmitData() {
      let list_indentity = taxForm.map((list: any) => {
        return {
          country: list.country,
          identification: list.idTypeOther,
          identification_number: list.idNo,
        };
      });
      const reqObj = {
        is_indian_citizen: SelectedRadio,
        fatcaReq: SelectedRadio ? [] : list_indentity,
      };
      return reqObj;
    },
    submitData(val: any) {
      Submit();
    },
  }));
  const Submit = async () => {
    props.setLoader(true);
    try {
      let listIndentity = taxForm.map((list: any, key: any) => {
        return {
          country: list.country,
          identification: list.idTypeOther,
          identification_number: list.idNo,
        };
      });
      let request = {
        requestType: "FATCA Update",
        dpID: await getDepositoryDet(),
        is_indian_citizen: SelectedRadio,
        fatcaReq: SelectedRadio ? [] : listIndentity,
        AutoQC: "NA",
      };

      let response = await CreateServiceRequestDetails(request);
      if (
        typeof response === "string" &&
        response.includes("Previous Request already open for this account-")
      ) {
        openExistSrPopup();
        return;
      } else {
        if (response && response.Message) {
          props.setLoader(false);
          props.onSubmit("FATCA Update", {
            content:
              "Your request will be updated within TWO working days. Status of your request will be communicated through Email",
            headerText: "We have Received your request!",
            popupType: "Success"
          });
        } else {
          openSRErrorPopup();
        }
      }
    } catch (error) {
      openSRErrorPopup();
    }
  };
  // console.log(props.loader, checkStatus);

  return (
    <>
      {/* {props.loader && (
        <div
          style={{
            textAlign: "center",
            paddingTop: "50px",
            paddingBottom: "50px",
          }}
        >
          <Loader size={50} color="blue"></Loader>
        </div>
      )} */}
      {!props.loader && (
        <div className="fatca">
          {checkStatus === "FATCA Validation is Success" && (
            <div>
              <h3 className="field-head">FATCA Information</h3>
              <p className="field-subHead">
                I am an Indian citizen & pay taxes in India, I do not pay taxes
                in USA or any other country{" "}
              </p>
              <div>
                <RadioButton
                  list={radioValues[0]}
                  name="taxpay"
                  selected={listing ? listing.value : radioValues[0].value}
                  onChange={(e) => {
                    onchanges(e.target.name, e.target.value);
                  }}
                />
                <RadioButton
                  list={radioValues[1]}
                  name="taxpay"
                  selected={listing ? listing.value : ""}
                  onChange={(e: any) => {
                    onchanges(e.target.name, e.target.value);
                  }}
                />
              </div>

              {!SelectedRadio && (
                <div>
                  <p className="text-indicator">
                    Please indicate ALL countries in which you are resident for
                    tax purpose and the associated Tax ID Number.
                  </p>
                  <TaxResident taxForm={taxForm} SetTaxForm={setTaxForm} />
                </div>
              )}
              {!props.childSr && (
                <p className="nobottom-space">
                  The changes mentioned will be applicable for your Trading and
                  Default Demat account
                </p>
              )}
            </div>
          )}

          {checkStatus ===
            "Another FATCA request is under process. Please raise any new requests only once those are processed" && (
            <StatusScreen
              headerText="FATCA under process"
              desc={
                "Another FATCA request is under process. You can't raise a new request till that is resolved."
              }
              status="Pending"
            />
          )}

          {checkStatus === "Your FATCA is updated" && (
            <StatusScreen
              headerText="Your FATCA is updated"
              desc={""}
              status="Pending"
            />
          )}
          {checkStatus ===
            "Your FATCA Validation has failed. Please get in touch with your RM." && (
            <FailedValidationScreen
              headerText="Validation failed"
              desc={checkStatus}
            />
          )}
        </div>
      )}
    </>
  );
});
